export default __webpack_public_path__ + "static/media/Real-Time Bluedot Wayfinding.4152c81c.svg";